import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PaddingTopBottomIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M10 15L10 5M10 15L7.5 13.3333M10 15L12.5 13.3333M10 5L7.5 6.66667M10 5L12.5 6.66667M17.5 2.5H2.5M17.5 17.5H2.5"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
